import { ArrowBackIosNewRounded } from '@mui/icons-material'
import { IconButton } from '@mui/material'
import React from 'react'

const BackButton = ({handleNavigate}) => {
  return (
    <IconButton
          id='backToHome'
          onClick={handleNavigate}
          sx={{
            p: 0,
            pr: 1,
            display: 'flex'
          }}
        >
          <ArrowBackIosNewRounded fontSize='small' />
        </IconButton>
  )
}

export default BackButton